import { computed, Directive, inject } from '@angular/core';

import { MessagesConstants } from '@shared/constants/messages.constants';
import { WorkflowStep } from '@shared/services/gql.service';
import { injectPermissions } from '@shared/store/auth/auth.service';
import { WorkflowQuery } from '@shared/store/workflow/workflow.query';

@Directive({ standalone: true })
export class PurchaseOrderWorkflowDirective {
  private readonly workflowQuery = inject(WorkflowQuery);

  permissions = injectPermissions({
    hasEditPurchaseOrder: 'PERMISSION_UPDATE_PURCHASE_ORDERS',
  });

  addPoActionTooltip = computed(() => {
    if (!this.permissions().hasEditPurchaseOrder) {
      return MessagesConstants.DO_NOT_HAVE_PERMISSIONS_TO_ACTION;
    }

    if (this.isChangeOrdersWorkflowLocked()) {
      return MessagesConstants.LOCKED_FOR_PERIOD_CLOSE;
    }

    return '';
  });
  addPoActionTooltips = computed(() => {
    const errors: string[] = [];

    if (!this.permissions().hasEditPurchaseOrder) {
      errors.push(MessagesConstants.DO_NOT_HAVE_PERMISSIONS_TO_ACTION);
    }

    if (this.isChangeOrdersWorkflowLocked()) {
      errors.push(MessagesConstants.LOCKED_FOR_PERIOD_CLOSE);
    }

    return errors.filter(Boolean);
  });

  readonly isChangeOrdersWorkflowLocked = this.workflowQuery.getLockStatusByWorkflowStepType(
    WorkflowStep.WF_STEP_MONTH_CLOSE_LOCK_CHANGE_ORDERS
  );

  disabledAddPoUI = computed(
    () => !this.permissions().hasEditPurchaseOrder || this.isChangeOrdersWorkflowLocked()
  );
}
